import { ThemeType, THEME_CONFIG } from '../enum/ThemeType';
import { ThemeActionTypes } from '../actions/theme';
import { SET_THEME } from '../actions/actionTypes';

const getSavedTheme = (): ThemeType => {
  const stored = localStorage.getItem('selected-theme') as ThemeType | null;

  if (!stored || !THEME_CONFIG[stored]) {
    localStorage.setItem('selected-theme', ThemeType.DEFAULT);
    return ThemeType.DEFAULT;
  }

  return stored;
};

const savedTheme = getSavedTheme();

const initialState: reducers.ThemeReducer = {
  currentTheme: THEME_CONFIG[savedTheme],
};

const themeReducer = (
  state = initialState,
  action: ThemeActionTypes
): reducers.ThemeReducer => {
  switch (action.type) {
    case SET_THEME: {
      const newTheme = THEME_CONFIG[action.payload]
        ? action.payload
        : ThemeType.DEFAULT;

      localStorage.setItem('selected-theme', newTheme);
      return {
        ...state,
        currentTheme: THEME_CONFIG[newTheme],
      };
    }

    default:
      return state;
  }
};

export default themeReducer;
